<template>
  <div class='col-lg-2 col-md-3 col-sm-4 col-6 episode-grid'>
    <router-link :to="url">
      <div class="eg-overlay">
        <div class="eg-overlay-center">
          <i class="material-icons mtc-icon">play_circle_filled</i>
        </div>
      </div>
      <span :alt="title" 
        class="eg-avatar" 
        :style="'background-image:url('+ avatar +')'"
      ></span>
      <p :title="title" class="mb-2">
        {{ title }}</p>
    </router-link>
  </div>
</template>

<script>
export default {
  props: [
    'avatar', 'title',
    'url'
  ]
}
</script>

<style lang="scss" scoped>
.episode-grid a {
    display: block;
    position: relative;
}

span.eg-avatar {
    width: 100%;
    height: 90px;
    display: block;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
}

.episode-grid p {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-top: 10px;
    color: whitesmoke;
    font-weight: 400;
}

.eg-overlay {
  width: 100%;
  height: 90px;
  position: absolute;
  background: rgba(0,0,0,.65);
  opacity: 0;
  .eg-overlay-center {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
    text-align: center;
    i {
      font-size: 60px;
      color: #c70c13;
      border-radius: 40px;
      padding: 0;
      &:before {
        content: "";
        width: 30px;
        height: 20px;
        background: #fff;
        display: block;
        position: absolute;
        top: 46%;
        left: 50%;
        transform: translate(-50%,-50%);
        z-index: -1;
      }
    }
  }
}

.episode-grid {
  position: relative;
  padding-bottom: 20px;
  .el-rate__icon {
    margin-right: 4px;
  }
  &:hover {
    transition-duration: .3s;
    transition-delay: .2s;
    .eg-overlay {
      opacity: 1;
      transition-duration: .3s;
    }
    p {
      color: #f22129;
      transition-duration: .5s;
    }
  }
}
</style>